export function getOnaUrl() {
    return "/ai";
}

export function getAgentExecutionUrl(agentExecutionId: string) {
    return `/ai/executions/${agentExecutionId}`;
}
